module.exports = __webpack_public_path__ + "img/shinoda.813ed43e.png";